import select from 'dom-select'

/**
 * This file enables the automatic initialization
 * of module Javascript based on the prevalence of
 * data-module="" attributes in the DOM. You should not
 * really need to interact with this file. It is
 * included once in main.js only.
 */

// Replaces the @halfhelix/kit enqueueModule global removed in S1-E0-03.
// All modules are eagerly loaded via require.context below, so we just need
// a resolved Promise to satisfy the Promise.all() chains in Vue async components.
window.enqueueModule = () => Promise.resolve()

// Build module registry at webpack compile time.
// Modules call window.enqueueModule during execution (above), so the stub
// must be defined before require.context triggers module evaluation.
const moduleContext = require.context('../../../modules', true, /\.js$/)
const vueContext = require.context('../../../modules', true, /\.vue$/)

const registry = {}

moduleContext.keys().forEach(key => {
  const name = key.split('/').pop().replace(/\.js$/, '')
  registry[name] = moduleContext(key)
})

vueContext.keys().forEach(key => {
  const name = key.split('/').pop().replace(/\.vue$/, '')
  registry[`${name}.vue`] = vueContext(key)
})

class Init {
  constructor () {
    this.modules = []
    this.init = this.init.bind(this)
  }

  init () {
    const nodes = select.all('[data-module]:not([data-initialized]), [is]:not([data-initialized])')

    for (let i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-initialized', 'true')

      const type = !!nodes[i].getAttribute('data-module')
        ? 'module'
        : 'vue'

      const name = type === 'module'
        ? nodes[i].getAttribute('data-module')
        : nodes[i].getAttribute('is')

      const key = type === 'module' ? name : `${name}.vue`
      const mod = registry[key]

      if (mod) {
        this.modules.push(mod)
        mod.default && mod.default(nodes[i])
      }
    }
  }
}

export default new Init()
